// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2UU7T","requiredAsterisk":"Info_requiredAsterisk__3U6iC"};